export default "__VITE_ASSET__yWMLpfYH__"